import styled from 'styled-components';
import { TRANSITION_SETTINGS, ICON_CONTAINER_WIDTH } from '../config.js';
import { IconContainer, FadeOutSpacer } from '../components/index.js';
import { Button } from '../../buttons/Button/Button.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var BUTTON_WIDTH = pxToRem(40);
var BUTTON_TRANSLATE = "calc((" + BUTTON_WIDTH + " - " + ICON_CONTAINER_WIDTH + ") / 2 * -1)";
var StyledButton = styled(Button).withConfig({
  displayName: "StyledButton",
  componentId: "sc-gg0pm7-0"
})(["justify-content:flex-start;min-width:", ";width:100%;padding:0;gap:0;transform:translateX(0);transition:all ", ";", ""], BUTTON_WIDTH, TRANSITION_SETTINGS, function (props) {
  return props.$minimized && "\n    transform: translateX(" + BUTTON_TRANSLATE + ");\n  ";
});
var StyledIconContainer = styled(IconContainer).withConfig({
  displayName: "StyledIconContainer",
  componentId: "sc-gg0pm7-1"
})(["min-width:", ";"], BUTTON_WIDTH);
var StyledFadeOutSpacer = styled(FadeOutSpacer).withConfig({
  displayName: "StyledFadeOutSpacer",
  componentId: "sc-gg0pm7-2"
})(["padding-right:", ";"], themeGet('spacing.md'));

export { StyledButton, StyledFadeOutSpacer, StyledIconContainer };
